import { atom } from 'jotai';
import { CollectionWordsResponse, PhrasesResponse, SavedWordData, WordData } from '@shared/types/words';

export interface LoadedWords {
  words: WordData[] | SavedWordData[];
  parts: Map<number, PhrasesResponse | CollectionWordsResponse>;
  totalParts: number;
  nextPartToLoad?: number;
  previewPending?: boolean;
  previewTargetSize?: number;
  previewLoadedSize?: number;
}

export function getWordsDataAtomDefaults(): LoadedWords {
  return {
    words: [],
    parts: new Map<number, PhrasesResponse>(),
    totalParts: 0,
    nextPartToLoad: 0,
    previewPending: false,
    previewTargetSize: 0,
    previewLoadedSize: 0,
  };
}

export const wordsDataAtom = atom<LoadedWords>(getWordsDataAtomDefaults());

export const wordsLoadingAtom = atom<boolean>(false);
export const wordsChunkLoadingAtom = atom<boolean>(false);

export const wordsErrorAtom = atom<string>('');

const _wordsLoadMoreAtom = atom<number>(0);
export const wordsLoadMoreAtom = atom<number, [void], void>(
  (get) => get(_wordsLoadMoreAtom),
  (get, set) => set(_wordsLoadMoreAtom, get(_wordsLoadMoreAtom) + 1)
);

export const wordToSaveAtom = atom<WordData | null>(null);

export const wordToDeleteAtom = atom<{ savedWordId: string, collectionId: string } | null>(null);

export function canLoadMoreWords(wordsData: LoadedWords): boolean {
  if (!wordsData.totalParts) {
    return false;
  }
  if (wordsData.previewPending) {
    return false;
  }
  const knownParts = Array.from(wordsData.parts.keys());
  const lastKnownPart = knownParts.length ? Math.max(...knownParts) : 0;
  const nextPart = wordsData.nextPartToLoad || (lastKnownPart > 0 ? lastKnownPart + 1 : 0);
  return nextPart >= 1 && nextPart <= wordsData.totalParts;
}
